<template>
  <div class="diadin">
    <!-- <div class="topbox">
      <div class="title" :class="active == 1 ? 'action' : ''" @click="active = 1">
        周边品采购
      </div>
      <div class="title" :class="active == 2 ? 'action' : ''" @click="active = 2">
        配件采购
      </div>
      <div class="title" :class="active == 3 ? 'action' : ''" @click="active = 3">
        购物车
      </div>
    </div> -->
    <!-- <attachments v-if="active == 1"></attachments>
    <attachment v-if="active == 2"></attachment>
    <cart v-if="active == 3"></cart> -->
  </div>
</template>

<script>
// import attachments from './attachments'
// import attachment from './attachment'
// import cart from './cart'
export default {
  // components: {
  //   attachment,
  //   attachments,
  //   cart,
  // },
  data () {
    return {
      active: 1,
    }
  },
  created () {
    console.log(this.$route)
    this.active = this.$route.query.active
  },
  methods: {
    handleEdit (index, row) {
      this.$router.push({
        path: '/sellcontent',
        query: {
          vin: row.vin,
          type: index,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.topbox {
  display: flex;
}

.title {
  width: 200px;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  height: 40px;
  line-height: 40px;
  margin-right: 40px;
  text-align: center;
  cursor: pointer;
}

.action {
  color: #fff;
  background-color: #409eff;
}
</style>
